"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineItemSortOrder = exports.LineItemStatus = exports.LineItemPayer = exports.LineItemUnitType = exports.LineItemType = void 0;
var LineItemType;
(function (LineItemType) {
    LineItemType["Dispatch"] = "dispatch";
    LineItemType["Fee"] = "fee";
    LineItemType["FlatRate"] = "flat_rate_total";
    LineItemType["Insurance"] = "insurance";
    LineItemType["Labor"] = "labor";
    LineItemType["Material"] = "material";
    LineItemType["SurgePrice"] = "surge_price";
    LineItemType["Tax"] = "tax";
    LineItemType["Tip"] = "tip";
})(LineItemType = exports.LineItemType || (exports.LineItemType = {}));
var LineItemUnitType;
(function (LineItemUnitType) {
    LineItemUnitType["Each"] = "each";
    LineItemUnitType["Hours"] = "hours";
    LineItemUnitType["Fixed"] = "fixed";
})(LineItemUnitType = exports.LineItemUnitType || (exports.LineItemUnitType = {}));
var LineItemPayer;
(function (LineItemPayer) {
    LineItemPayer["Organization"] = "organization";
    LineItemPayer["Consumer"] = "consumer";
})(LineItemPayer = exports.LineItemPayer || (exports.LineItemPayer = {}));
var LineItemStatus;
(function (LineItemStatus) {
    LineItemStatus["Active"] = "Active";
    LineItemStatus["RolledBack"] = "Rolled Back";
})(LineItemStatus = exports.LineItemStatus || (exports.LineItemStatus = {}));
exports.lineItemSortOrder = Object.freeze({
    [LineItemType.Dispatch]: 1,
    [LineItemType.Fee]: 2,
    [LineItemType.FlatRate]: 3,
    [LineItemType.Insurance]: 4,
    [LineItemType.Labor]: 5,
    [LineItemType.SurgePrice]: 6,
    [LineItemType.Tax]: 7,
    [LineItemType.Tip]: 8,
    [LineItemType.Material]: 9,
});
